import { Badge } from './Badge';

export const BooleanBadge = ({ isEnabled }: { isEnabled: boolean }) => (
  <Badge variant={isEnabled ? 'success' : 'error'}>{isEnabled ? 'Enabled' : 'Disabled'}</Badge>
);
